import { AuthLevel } from '../enums/auth-level.enum';

export class AccessPolicy {
  public applicationId: string;
  public groupId: string;
  public authLevel: AuthLevel;
  public updatedAt?: string;

  constructor(backEndAccessPolicy?: BackEndAccessPolicy)  {
    if (backEndAccessPolicy) {
      this.applicationId = backEndAccessPolicy.application_id;
      this.groupId = backEndAccessPolicy.group_id;
      this.authLevel = backEndAccessPolicy.auth_level;
      this.updatedAt = backEndAccessPolicy.updated_at;
    }
  }

  public toBackEnd(): BackEndAccessPolicy {
    return {
      application_id: this.applicationId,
      group_id: this.groupId,
      auth_level: this.authLevel,
      updated_at: this.updatedAt,
    };
  }
}

export interface BackEndAccessPolicy {
  application_id: string;
  group_id: string;
  auth_level: AuthLevel;
  updated_at?: string;
}
